import URITemplate from "urijs/src/URITemplate";

export default Object.freeze({

    ROSCONGRESS_URL: process.env.VUE_APP_ROSCONGRESS_URL,

    getUrl(template, options) {
        return (new URITemplate(template)).expand(options).toString();
    },

    getFullUrl(name, options, baseURL) {
        const template = this[name] || name;
        return (baseURL || this.ROSCONGRESS_URL) + this.getUrl(template, options);
    },

    BITRIX_ELEMENT:         '/bitrix/admin/iblock_element_edit.php?IBLOCK_ID={IBLOCK_ID}&type={IBLOCK_TYPE}&lang=ru&ID={ID}&find_section_section=0&WF=Y',

    SESSION:                '/sessions/{code}/',

    getSessionUrl(options) {
        return this.getFullUrl(this.SESSION, options);
    },
    getSessionBitrixUrl(options) {
        return this.getFullUrl(this.BITRIX_ELEMENT, {IBLOCK_ID: 6, IBLOCK_TYPE: 'content', ID: options.id_session_bitrix});
    },
    getSessionCmsRoute(options) {
        return {name: 'ForumEventSession', params: {...options, ID_SESSION: options.id_session_bitrix}};
    },

    EVENT:                  '/events/{code}/',

    getEventUrl(options) {
        return this.getFullUrl(this.EVENT, options);
    },
    getEventBitrixUrl(options) {
        return this.getFullUrl(this.BITRIX_ELEMENT, {IBLOCK_ID: 19, IBLOCK_TYPE: 'content', ID: options.id_events_bitrix});
    },

    SPEAKER:                '/speakers/id/{id_speaker_bitrix}/',

    getSpeakerUrl(options) {
        return this.getFullUrl(this.SPEAKER, options);
    },
    getSpeakerBitrixUrl(options) {
        return this.getFullUrl(this.BITRIX_ELEMENT, {IBLOCK_ID: 2, IBLOCK_TYPE: 'dictionary', ID: options.id_speaker_bitrix});
    },

    BRIGHT_QUOTE:  '/speakers/bright-quotes/id/{id_bright_quotes}/',
    getBrightQuoteUrl(options) {
        return this.getFullUrl(this.BRIGHT_QUOTE, options);
    },
    getBrightQuoteBitrixUrl(options) {
        return this.getFullUrl(this.BITRIX_ELEMENT, {IBLOCK_ID: 38, IBLOCK_TYPE: 'content', ID: options.id_bright_quotes});
    },

    DIGEST:                 '/materials/id/{id_analytics}/',
    getDigestUrl(options) {
        return this.getFullUrl(this.DIGEST, options);
    },
    getDigestBitrixUrl(options) {
        return this.getFullUrl(this.BITRIX_ELEMENT, {IBLOCK_ID: 5, IBLOCK_TYPE: 'content', ID: options.id_analytics});
    },

    REPORT:                 '/materials/id/{id_analytics}/',
    getDocumentUrl(options) {
        return this.getFullUrl(this.REPORT, options);
    },
    getDocumentBitrixUrl(options) {
        return this.getFullUrl(this.BITRIX_ELEMENT, {IBLOCK_ID: 5, IBLOCK_TYPE: 'content', ID: options.id_analytics});
    },

    getUploadedUrl(file) {
        return file ? [this.ROSCONGRESS_URL, 'upload', file].join('/') : undefined;
    },

});
